import MenuContext, { MenuStatesValues } from 'contexts/MenuContext';
import { useState } from 'react';
import ResponsiveMenu from './ResponsiveMenu';
import WebMenu from './WebMenu';

const Header = () => {
  const [MenuStates, setMenuStates] = useState<MenuStatesValues | any>(MenuStatesValues.CLOSE);

  return (
    <>
      <MenuContext.Provider value={{ MenuStates, setMenuStates }}>
        <WebMenu />
        <ResponsiveMenu />
      </MenuContext.Provider>
    </>
  );
};

export default Header;
